// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { useLedgersDataView } from "@store/Framework/Store/Store/Data/Ledgers/LedgersHooks";
import { useLedgersParameter } from "@store/Framework/Store/Store/Pages/BillingStatus/BillingStatusHooks";
import updateSearchFields from "@store/Framework/Store/Store/Pages/BillingStatus/Handlers/UpdateSearchFields";
import constants from "@store/constants";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import React from "react";

type BillingStatusListPaginationProps = WidgetProps;

export interface BillingStatusListPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const paginationStyles: BillingStatusListPaginationStyles = {};

const styles = paginationStyles;

const BillingStatusListPagination = (props: BillingStatusListPaginationProps) => {
    const dispatch = useAppDispatch();
    const ledgersParameter = useLedgersParameter();
    const baseLedgersDataView = useLedgersDataView(ledgersParameter);
    const ledgersDataView = usePersistentDataView(baseLedgersDataView);

    const changePage = (newPageIndex: number) => {
        dispatch(
            updateSearchFields({
                page: newPageIndex,
            }),
        );
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        dispatch(
            updateSearchFields({
                page: 1,
                pageSize: newPageSize,
            }),
        );
    };

    if (!ledgersDataView.value) {
        return null;
    }

    const { pagination } = ledgersDataView;
    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            prevPage={pagination.prevPageUri}
            nextPage={pagination.nextPageUri}
        />
    );
};

const widgetModule: WidgetModule = {
    component: BillingStatusListPagination,
    definition: {
        group: constants.widgetGroup.billingStatus,
        displayName: "Billing Status List Pagination",
        allowedContexts: [constants.pageType.billingStatus],
        isSystem: true,
    },
};

export default widgetModule;
